
      import ZoomIn from './zoom-in.vue'
      import type { App, Plugin } from 'vue'

      export const ZoomInPlugin: Plugin = {
        install(app: App) {
          app.component('ZoomIn', ZoomIn)
        },
      }
      export { ZoomIn }
      